import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nao-autenticado',
  templateUrl: './nao-autenticado.component.html',
  styleUrls: ['./nao-autenticado.component.scss']
})
export class NaoAutenticadoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
